import { useScrollReveal } from '@/hooks/useScrollReveal';

interface FinalCTAProps {
  projectTitle: string;
}

const WHATSAPP_NUMBER = '+923348872555';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}`;
const PHONE_URL = `tel:${WHATSAPP_NUMBER}`;

export default function FinalCTA({ projectTitle }: FinalCTAProps) {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} className="relative w-full py-20 md:py-28 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxury modern residential estate aerial view at golden hour with warm orange and amber lighting dramatic sky elegant architecture Islamabad Pakistan real estate photography cinematic wide angle high resolution"
          alt="Investment background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a]/90 via-[#0a0a0a]/75 to-[#0a0a0a]/60" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-10 lg:px-16 text-center">
        <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-[11px] font-bold text-[#d4853a] uppercase tracking-[0.25em] mb-5">
            Begin Your Investment Journey
          </span>
          <h2 className="text-2xl md:text-4xl lg:text-[2.75rem] font-extrabold text-white leading-[1.15] mb-5">
            Ready To Secure Your Next{' '}
            <span className="text-[#d4853a]">Property Investment</span>?
          </h2>
          <p className="text-[15px] md:text-base text-white/55 max-w-2xl mx-auto leading-relaxed mb-9">
            Let our expert team guide you through every step — from consultation and site visits to documentation and possession. Your trust is our commitment.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-8 py-4 bg-[#d4853a] text-white text-[14px] font-bold rounded-xl transition-all duration-300 hover:bg-[#c27630] hover:shadow-[0_16px_48px_rgba(212,133,58,0.4)] hover:-translate-y-0.5 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-[18px]" />
              WhatsApp Inquiry
            </a>
            <a
              href={PHONE_URL}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-4 bg-white/[0.08] backdrop-blur-md text-white text-[14px] font-semibold rounded-xl border border-white/[0.12] transition-all duration-300 hover:bg-white/[0.14] hover:border-white/[0.2] hover:-translate-y-0.5 whitespace-nowrap"
            >
              <i className="ri-phone-line text-[16px]" />
              Call Now
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-4 bg-white/[0.05] text-white/80 text-[14px] font-medium rounded-xl border border-white/[0.08] transition-all duration-300 hover:bg-white/[0.1] hover:text-white/95 hover:-translate-y-0.5 whitespace-nowrap"
            >
              <i className="ri-car-line text-[16px]" />
              Book Site Visit
            </a>
          </div>

          {/* Trust line */}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-5 text-[12px] text-white/40">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-[#d4853a]" />
              NOC Approved
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-verified-badge-line text-[#d4853a]" />
              Verified Project
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-global-line text-[#d4853a]" />
              Overseas Friendly
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}